// extracted by mini-css-extract-plugin
module.exports = {"spreader":"spreader___1Hsta"};